import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WelcomeComponent } from './components/welcome/welcome.component';
import { RouterModule } from '@angular/router';
import { SalesRepComponent } from './sales-rep.component';
import { SalesRepRoutingModule } from './sales-rep-routing.module';



@NgModule({
  declarations: [
    SalesRepComponent,
    WelcomeComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SalesRepRoutingModule
  ]
})
export class SalesRepModule { }
